var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandNetflix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 32,
    viewBox: "0 0 106 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21557_5514)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21557_5514",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 32,
    fill: "#919EAB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21557_5514)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3247 24.7109C25.6699 24.8277 25.0082 24.8956 24.3355 24.9647C23.8823 25.0112 23.4241 25.0582 22.9598 25.1211L19.4408 14.6524V25.5704C18.4521 25.6761 17.5415 25.8136 16.6103 25.9542L16.3066 26V6H19.2295L23.2289 17.3478V6H26.3247V24.7109ZM32.3827 13.3242C32.9914 13.3242 33.7654 13.3089 34.5232 13.294C35.2497 13.2797 35.9612 13.2656 36.4977 13.2656V16.3905C35.1324 16.3905 33.5365 16.3905 32.3827 16.4492V21.0977C32.8954 21.0644 33.408 21.0281 33.921 20.9917C35.217 20.8997 36.5158 20.8075 37.8244 20.7655V23.7732L29.3061 24.4569V6H37.8244V9.125H32.3827V13.3242ZM46.0739 9.12508H49.2658L49.2659 6H39.8055V9.12508H42.9974V23.539C43.9972 23.5001 45.0355 23.5001 46.0739 23.5001V9.12508ZM54.2638 13.1094H58.4749V16.2344H54.2638V23.3243H51.2447V6H59.8401V9.125H54.2638V13.1094ZM68.672 20.7782C67.4046 20.6989 66.1176 20.6183 64.8407 20.5898V6H61.7642V23.539C64.5716 23.5978 67.3213 23.7733 70.0709 23.9492V20.8632C69.6085 20.8369 69.1413 20.8076 68.672 20.7782ZM72.6656 24.1641L72.8271 24.1737C73.7597 24.2293 74.7393 24.2878 75.6844 24.3984V6H72.6656V24.1641ZM85.2592 15.5117L89.1626 6H85.7976L83.6439 11.2539L81.6249 6H78.3177L81.8943 15.3945L77.9333 24.5546C78.3943 24.6192 78.8488 24.6671 79.3021 24.7149C79.9453 24.7827 80.5863 24.8503 81.2406 24.965L83.4902 19.6524L85.7013 25.4336C85.9896 25.4824 86.2778 25.5324 86.566 25.5824C87.4315 25.7326 88.2971 25.8828 89.1626 26L85.2592 15.5117Z",
    fill: "#919EAB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21557_5514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandNetflix);
export default __webpack_public_path__ + "static/media/brand_netflix.39ea2150db73c4e3012c7bfe9b3f83fc.svg";
export { ForwardRef as ReactComponent };